module.exports = __webpack_public_path__ + "img/Germantown_Grille@1x.0c7c4f43.webp";